// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ePam","top":"styles_top__3FJax"};